import { formatMoney, formatPercent } from '@nemuru-eng/js-api-client';
import React from 'react';

import { amountToValueMoneyMapper } from '../../../../../../../../utils/mappers/amountToValueMoneyMapper';
import { Font } from '../../../../../../../shared/components/Font';
import { Text } from '../../../../../../../shared/components/Text';
import { TransactionsListRowProps } from '../../../types/TransactionsListRowProps';

export const amountAndVatFieldColumn = ({ flex }: { flex?: number }) => ({
  flex: flex ?? 0.5,
  field: 'amount',
  align: 'left',
  headerName: (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Font variant={'h5'} color={'textPrimary'}>
        <Text strong tId={'TOTAL_AMOUNT'} />
      </Font>
      <Font variant={'body2'}>
        <Text tId={'VAT'} />
      </Font>
    </div>
  ),
  renderCell: (rowData: TransactionsListRowProps) => (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          whiteSpace: 'break-spaces',
          lineHeight: '1.43',
        }}
      >
        <Font color={'textPrimary'} variant={'body2'}>
          <div className={'line-clamp-3'}>
            <strong>{formatMoney(amountToValueMoneyMapper(rowData.row.amount))}</strong>
          </div>
        </Font>
        <Font color={'textSecondary'} variant={'body2'}>
          <div className={'line-clamp-3'}>{`${formatMoney(
            amountToValueMoneyMapper(rowData.row.vatAmount),
          )} (${formatPercent(rowData.row.vatRate)})`}</div>
        </Font>
      </div>
    </>
  ),
});
